import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBasilCrossOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.46094 15.5351L15.5329 8.46509M8.46094 8.46509L15.5329 15.5351",
		stroke: "#444444",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgBasilCrossOutline;
